import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

const isConfigured = supabaseUrl && supabaseUrl !== 'https://your-project.supabase.co' && supabaseAnonKey && supabaseAnonKey !== 'your-anon-key';

if (!isConfigured) {
  console.warn('⚠️ Supabase environment variables are missing or use placeholders. Backend features will be disabled. Check your .env file.');
}

// Create a real client or a safe proxy to prevent crashes during initialization
export const supabase = isConfigured 
  ? createClient(supabaseUrl, supabaseAnonKey)
  : new Proxy({}, { 
      get: (target, prop) => {
        if (prop === 'auth') return { 
          onAuthStateChange: () => ({ data: { subscription: { unsubscribe: () => {} } } }),
          getSession: async () => ({ data: { session: null }, error: null }),
          getUser: async () => ({ data: { user: null }, error: null })
        };
        return () => ({ 
          from: () => ({ 
            select: () => ({ 
              eq: () => ({ single: async () => ({ data: null, error: new Error('Supabase not configured') }) }) 
            }) 
          }) 
        });
      }
    });
